import { useFeatureFlagEnabled } from '@taxfix/scouts-helpers'

import { useStickyOnboardingProductSelectionExperiment } from '@/experiments/use-sticky-onboarding-product-selection-experiment'

export const usePostHogFeatureFlags = () => {
    const featureGoodBetterBestPublic = useFeatureFlagEnabled('feat-gbb-public')
    const isKycEnforcementEnabled = useFeatureFlagEnabled('self-assessment-kyc-enforcement')
    const isSelfAssessmentDocumentsSimplifiedViewEnabled = useFeatureFlagEnabled(
        'self-assessment-documents-simplified-view'
    )
    const featureSelfAssessmentOnboardingRevamp = useFeatureFlagEnabled('feat-self-assessment-onboarding-revamp')
    const featureInvoicePricesIncludeVAT = useFeatureFlagEnabled('feat-invoice-prices-include-vat')
    const { isTestVariant: isOnboardingProductSelectionExperimentParticipant } =
        useStickyOnboardingProductSelectionExperiment()

    return {
        featureKycEnforcement: !!isKycEnforcementEnabled,
        featureSelfAssessmentDocumentsSimplifiedView: !!isSelfAssessmentDocumentsSimplifiedViewEnabled,
        featureSelfAssessmentOnboardingRevamp: !!featureSelfAssessmentOnboardingRevamp,
        featureInvoicePricesIncludeVAT: !!featureInvoicePricesIncludeVAT,
        featureOnboardingProductSelectionUiUpdates: isOnboardingProductSelectionExperimentParticipant,
        featureGoodBetterBestPublic: !!featureGoodBetterBestPublic,
    }
}
